// UnauthorizedPage.js

import React from 'react';
import { Container, Box, Typography } from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';
import { useNavigate } from 'react-router-dom';
import { Button } from '@voicecare.ai/ui-library';

const UnauthorizedPage = ({selectMenu}) => {
  const navigate = useNavigate();

  selectMenu('Unauthorize')

  const handleGoHome = () => {
    selectMenu('Home')
    navigate('/home');
  };

  return (
    <Container maxWidth="sm" sx={{ textAlign: 'center', mt: 8 }}>
      <Box sx={{ mb: 4 }}>
        <BlockIcon sx={{ fontSize: 80, color: 'error.main' }} />
      </Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Access Denied
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        We’re sorry, but you do not have the required permissions to access this page. Please contact your system administrator or help desk for further assistance.
      </Typography>
      <Button width="100%" label="Go to Home Page" onClick={handleGoHome} />
    </Container>
  );
};

export default UnauthorizedPage;